import {
  Activity,
  AlertCircle,
  Award,
  BarChart3,
  Briefcase,
  Building,
  Building2,
  Calculator,
  Calendar,
  CheckSquare,
  ChevronDown,
  ChevronRight,
  ClipboardList,
  Cog,
  Database,
  DollarSign,
  Download,
  Factory,
  FileText,
  Filter,
  FolderOpen,
  GitBranch,
  HelpCircle,
  History,
  Home,
  Layers,
  Lock,
  Mail,
  Package,
  Phone,
  PieChart,
  Search,
  Settings,
  Shield,
  ShoppingCart,
  Star,
  Store,
  Target,
  TrendingUp,
  Truck,
  Upload,
  User,
  Users,
  Compass,
  Scale,
  ShieldCheck,
  ListChecks
} from 'lucide-react';
import React from 'react';

// Registry chỉ chứa những icons được phép sử dụng
const iconRegistry: Record<string, React.ComponentType<any>> = {
  Activity,
  AlertCircle,
  Award,
  BarChart3,
  Briefcase,
  Building,
  Building2,
  Calculator,
  Calendar,
  CheckSquare,
  ChevronDown,
  ChevronRight,
  ClipboardList,
  Cog,
  Database,
  DollarSign,
  Download,
  Factory,
  FileText,
  Filter,
  FolderOpen,
  GitBranch,
  HelpCircle,
  History,
  Home,
  Layers,
  Lock,
  Mail,
  Package,
  Phone,
  PieChart,
  Search,
  Settings,
  Shield,
  ShoppingCart,
  Star,
  Store,
  Target,
  TrendingUp,
  Truck,
  Upload,
  User,
  Users,
  Compass,
  Scale,
  ShieldCheck,
  ListChecks
};

export const generateIcon = (iconName: string, size: number = 18, color: string = '#64748b') => {
  const IconComponent = iconRegistry[iconName];

  if (!IconComponent) {
    console.warn(`Icon "${iconName}" not found in registry. Available icons: ${Object.keys(iconRegistry).join(', ')}`);
    return React.createElement(HelpCircle, { size, color });
  }

  return React.createElement(IconComponent, { size, color });
};

// Export danh sách icons có sẵn
export const getAvailableIcons = (): string[] => {
  return Object.keys(iconRegistry);
};

// Validate icon name
export const isValidIcon = (iconName: string): boolean => {
  return iconName in iconRegistry;
};
